import { useLocation } from "react-router-dom";

export type DetailRouteKind = "contact" | "organization" | "deal" | "partner";

export interface DetailRouteContext {
  kind: DetailRouteKind;
  id: string;
}

const ROUTES: Array<{ regex: RegExp; kind: DetailRouteKind }> = [
  { regex: /^\/contacts\/([0-9a-fA-F-]{36})/, kind: "contact" },
  { regex: /^\/organizations\/([0-9a-fA-F-]{36})/, kind: "organization" },
  { regex: /^\/deals\/([0-9a-fA-F-]{36})/, kind: "deal" },
  { regex: /^\/partners\/([0-9a-fA-F-]{36})/, kind: "partner" },
];

export function useDetailRoute(): DetailRouteContext | null {
  const { pathname } = useLocation();
  for (const { regex, kind } of ROUTES) {
    const m = pathname.match(regex);
    if (m && m[1]) return { kind, id: m[1] };
  }
  return null;
}
